export default __webpack_public_path__ + "static/media/mastercard.0f40892a.svg";